import migrateZapCardsSection from './ZapCardsSection';

export default [migrateZapCardsSection];
